module.exports = __webpack_public_path__ + "img/baout_honor4.6fb5be67.png";